type StatsGridProps = {
  thisWeekCalls: number
  needsPrepCount: number
  inProgressCount: number
  readyCount: number
}

export function StatsGrid({ thisWeekCalls, needsPrepCount, inProgressCount, readyCount }: StatsGridProps) {
  const meetingLabel = thisWeekCalls === 1 ? 'meeting' : 'meetings'

  return (
    // data-tour anchors the assistant walkthroughs — see assistant/mockData.ts
    <div data-tour="stats-row" className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
      <div className="bg-white rounded-lg border border-gray-200 p-4">
        <div className="text-sm text-gray-600 mb-1">THIS WEEK</div>
        <div className="text-2xl font-bold text-gray-900">
          {thisWeekCalls} {meetingLabel} scheduled
        </div>
      </div>
      <div className="bg-white rounded-lg border border-gray-200 p-4">
        <div className="text-sm text-gray-600 mb-1">NEEDS PREP</div>
        <div className="text-2xl font-bold text-red-600 mb-1">{needsPrepCount}</div>
        <div className="text-xs text-red-600">not started or incomplete</div>
      </div>
      <div className="bg-white rounded-lg border border-gray-200 p-4">
        <div className="text-sm text-gray-600 mb-1">IN PROGRESS</div>
        <div className="text-2xl font-bold text-orange-600 mb-1">{inProgressCount}</div>
        <div className="text-xs text-orange-600">partially prepared</div>
      </div>
      <div className="bg-white rounded-lg border border-gray-200 p-4">
        <div className="text-sm text-gray-600 mb-1">READY</div>
        <div className="text-2xl font-bold text-green-600 mb-1">{readyCount}</div>
        <div className="text-xs text-green-600">fully prepared</div>
      </div>
    </div>
  )
}
